import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import UserConfigurationDictionaryObject from 'owa-service/lib/contract/UserConfigurationDictionaryObject';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import serviceUserConfiguration from 'owa-service/lib/factory/serviceUserConfiguration';
import updateUserConfigurationOperation from 'owa-service/lib/operation/updateUserConfigurationOperation';
import updateUserConfigurationOwaRequest from 'owa-service/lib/factory/updateUserConfigurationOwaRequest';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import userConfigurationNameType from 'owa-service/lib/factory/userConfigurationNameType';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export const VIEW_STATE_CONFIGURATION: string = 'OWA.ViewStateConfiguration';
export const USER_OPTIONS_CONFIGURATION: string = 'OWA.UserOptions';

const USER_OPTIONS_BASEFOLDERID_NAME: DistinguishedFolderIdName = 'root';
const UPDATE_FOLDER_VIEW_STATE_DELAY_MS = 10 * 1000;

let updateFolderViewStateTimer: any = null;

/**
 * Delay update the folder view state service
 * @param userConfiguration the user configuration
 */
export default function updateFolderViewStateService(userConfiguration: OwaUserConfiguration) {
    const folderViewState = userConfiguration.ViewStateConfiguration.FolderViewState;

    if (folderViewState) {
        const serializedFolderViewState: string[] = [];

        for (let i = 0; i < folderViewState.length; i++) {
            serializedFolderViewState.push(folderViewState[i]);
        }

        // Save this changes with a timer so we can batch all of them together.
        if (!updateFolderViewStateTimer) {
            updateFolderViewStateTimer = setTimeout(function() {
                // Clear the time handle.
                updateFolderViewStateTimer = null;

                // Make the call.
                updateUserConfigurationService(
                    VIEW_STATE_CONFIGURATION,
                    {
                        // Key
                        Type: 'String',
                        Value: ['FolderViewState'],
                    },
                    {
                        // Value
                        Type: 'StringArray',
                        Value: serializedFolderViewState,
                    }
                );
            }, UPDATE_FOLDER_VIEW_STATE_DELAY_MS);
        }
    }
}

/**
 * Update the user configuration service internal
 * @param userConfigurationName the user configuration name
 * @param key the key which is the field to update
 * @param value the value of the field
 */
function updateUserConfigurationService(
    userConfigurationName: string,
    key: UserConfigurationDictionaryObject,
    value: UserConfigurationDictionaryObject
): Promise<SingleResponseMessage> {
    const newUserConfiguration = serviceUserConfiguration({
        UserConfigurationName: userConfigurationNameType({
            Name: userConfigurationName,
            BaseFolderId: distinguishedFolderId({
                Id: USER_OPTIONS_BASEFOLDERID_NAME,
            }),
        }),
        Dictionary: [
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject(key),
                DictionaryValue: userConfigurationDictionaryObject(value),
            }),
        ],
    });

    return updateUserConfigurationOperation({
        Header: getJsonRequestHeader(),
        Body: updateUserConfigurationOwaRequest({
            UserConfiguration: newUserConfiguration,
        }),
    }).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}
